import React from "react";
import PageWrapper from "../components/PageWrapper";
import WhyMonkziSection from "../components/WhyMonkziSection";
import MonkziLiveSection from "../components/MonkziLiveSection";


const tokenomics = [
  { label: "Total Supply", value: "1,000,000,000 MONKZI" },
  { label: "USDT Pair (Liquidity)", value: "500,000,000 (50%)" },
  { label: "BNB Pair (Liquidity)", value: "100,000,000 (10%)" },
  { label: "Team Reserve", value: "100,000,000 (10%)" },
  { label: "Burn + Giveaways", value: "100,000,000 (10%)" },
  { label: "Public Circulation", value: "200,000,000 (20%)" },
];

export default function Home() {
  return (
    <PageWrapper>
      <div
        className="page-container"
        style={{
          maxWidth: "900px",
          margin: "auto",
          marginTop: "64px",                 // ⬅️ small top margin so the top-right menu isn’t overlapped on mobile
          borderRadius: "32px",
          padding: "32px 18px",
          background: "rgba(0,0,0,0.10)",
          boxSizing: "border-box",
        }}
      >
        {/* HERO */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <h1 style={{ fontSize: "2.7em", fontWeight: "bold", color: "#fff", letterSpacing: "2px", textShadow: "0 2px 14px #0c1922", marginBottom: "12px" }}>Monkilla</h1>
          <p style={{ fontSize: "1.3em", color: "#e0e0e0", lineHeight: 1.4 }}>
            Meditate. Meme. Moon!<br />The meme coin with zen & hype.
          </p>
        </div>

        <WhyMonkziSection />

        {/* CTAs */}
        <div className="home-btns" style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center", marginBottom: "26px" }}>
          <a href="https://forms.gle/3nsLxLnJR3J8nVtL6" target="_blank" rel="noopener noreferrer" style={{ background: "#FFD700", color: "#07333c", padding: "14px 28px", borderRadius: "30px", fontWeight: "bold", textDecoration: "none", fontSize: "1.1em", flex: "1 1 200px", textAlign: "center" }}>🎁 Giveaway Register</a>
          <a href="/whitepaper.pdf" target="_blank" rel="noopener noreferrer" style={{ background: "rgba(255,255,255,0.07)", color: "#FFD700", border: "2px solid #FFD700", padding: "14px 28px", borderRadius: "30px", fontWeight: "bold", textDecoration: "none", fontSize: "1.1em", flex: "1 1 200px", textAlign: "center" }}>📄 Whitepaper</a>
        </div>

        {/* TOKENOMICS */}
        <section style={{ margin: "22px 0 32px", background: "rgba(20,30,40,0.78)", borderRadius: "18px", padding: "18px" }}>
          <h2 style={{ color: "#FFD700", fontWeight: "bold", fontSize: "1.28em", marginBottom: "16px" }}>🍌 Tokenomics</h2>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "14px" }}>
            {tokenomics.map(({ label, value }, i) => (
              <div key={i} style={{ flex: "1 1 200px", background: "rgba(30,40,50,0.73)", borderRadius: "16px", padding: "12px" }}>
                <div style={{ color: "#FFD700", fontWeight: "bold", marginBottom: "6px" }}>{label}</div>
                <div style={{ color: "#fff" }}>{value}</div>
              </div>
            ))}
          </div>
        </section>

        {/* ROADMAP */}
        <section style={{ margin: "28px 0 32px", background: "rgba(20,30,40,0.78)", borderRadius: "18px", padding: "18px" }}>
          <h2 style={{ color: "#FFD700", fontWeight: "bold", fontSize: "1.28em", marginBottom: "16px" }}>🗺️ Roadmap</h2>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
            <div style={{ color: "#fff" , flex: "1 1 220px", background: "rgba(40,50,70,0.82)", borderRadius: "18px", padding: "12px" }}>
              <b>Q2 2025</b>
              <ul style={{ marginTop: "8px" }}>
                <li>Launch website & initial listings</li>
                <li>First community giveaways & burns</li>
              </ul>
            </div>
            <div style={{ color: "#fff",flex: "1 1 220px", background: "rgba(40,50,70,0.82)", borderRadius: "18px", padding: "12px" }}>
              <b>Q3 2025</b>
              <ul style={{ marginTop: "8px" }}>
                <li>UX revamp & dApp launchpad</li>
                <li>CoinGecko & CMC submissions</li>
                <li>Mobile app release</li>
              </ul>
            </div>
          </div>
        </section>

        {/* HOW TO BUY */}
        <div style={{ textAlign: "center", margin: "30px 0" }}>
          <a href="/how-to-buy" style={{ display: "inline-block", background: "#FFD700", color: "#07333c", fontWeight: "bold", fontSize: "1.18em", padding: "15px 38px", borderRadius: "30px", textDecoration: "none", boxShadow: "0 4px 20px rgba(246,195,67,0.12)", letterSpacing: "1px" }}>🚀 How to Buy</a>
        </div>

        {/* LIVE PRICE */}
        <MonkziLiveSection />

        {/* LISTED ON */}
        <section style={{ margin: "32px 0 16px" }}>
          <h2 style={{ color: "#FFD700", fontSize: "1.5em", fontWeight: "bold", marginBottom: "12px" }}>📍 Listed On</h2>
          <ul style={{ display: "flex", flexWrap: "wrap", gap: "10px", listStyle: "none", padding: 0 }}>
            {[
              { name: "CoinSniper", url: "https://coinsniper.net/coin/84164" },
              { name: "CoinHunt", url: "https://coinhunt.cc/coin/68886ae4f3b2fcf77fe96ccf" },
              { name: "CoinMooner", url: "https://coinmooner.com/coins/monkilla-monkzi" },
              { name: "FreshCoins", url: "https://freshcoins.io/coins/monkilla" },
              { name: "GeckoTerminal", url: "https://geckoterminal.com/bsc/pools/0xbfd2c20196e21db1d7f47ce5c59b1e00bab99138" }
            ].map(site => (
              <li key={site.name} style={{ flex: "1 1 120px" }}>
                <a href={site.url} target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", background: "#f6c343", color: "#191919", padding: "8px 12px", borderRadius: "20px", fontWeight: "bold", textAlign: "center", textDecoration: "none", width: "100%" }}>{site.name}</a>
              </li>
            ))}
          </ul>
        </section>

        {/* SOCIAL LINKS */}
        <div style={{ borderTop: "1px solid #404040", paddingTop: "16px", textAlign: "center" }}>
          <span style={{ color: "#FFD700", fontWeight: "bold", marginRight: "12px" }}>Follow us:</span>
          {[
            { name: "Telegram", url: "https://t.me/monkillaofficial" },
            { name: "X", url: "https://twitter.com/monkillacoin" },
            { name: "Instagram", url: "https://instagram.com/monkilla.official" },
            { name: "Discord", url: "https://discord.gg/q8MDWV4K" },
            { name: "Email", url: "mailto:info@monkilla.com" }
          ].map((s, i) => (
            <a key={i} href={s.url} target="_blank" rel="noopener noreferrer" style={{ color: "#fff", margin: "0 8px", fontWeight: "bold", fontSize: "0.95em", textDecoration: "none" }}>{s.name}</a>
          ))}

          {/* ✅ BscScan verification phrase (public, reviewer-friendly) */}
          <div style={{ marginTop: "10px", color: "#bdbdbd", fontSize: "0.9em" }}>
            BscScan logo submission – MONKZI – 13 Aug 2025
          </div>
        </div>
      </div>

      {/* Responsive tweaks */}
      <style jsx>{`
        @media (max-width: 700px) {
          .home-btns { flex-direction: column; }
          section div[style*="flex: 1 1"] { flex: 1 1 100%; }
          .page-container { margin-top: 84px; }  /* extra breathing room so the top-right menu is visible on small screens */
        }
      `}</style>
    </PageWrapper>
  );
}
